module.exports = __webpack_public_path__ + "meiryob.1e54c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/fonts/woff/meiryob.woff
// module id = ./src/_asset/sources/assets/fonts/woff/meiryob.woff
// module chunks = main